var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "nonzero",
    d: "M12.227 6.36c.693 0 1.572-.47 2.09-1.094.469-.567.8-1.358.8-2.149 0-.107-.01-.215-.029-.303-.761.03-1.699.518-2.256 1.172-.43.498-.84 1.28-.84 2.08 0 .118.02.235.03.274.049.01.127.02.205.02zM9.795 18.175c.948 0 1.368-.635 2.55-.635 1.19 0 1.464.615 2.509.615s1.738-.957 2.393-1.894c.722-1.075 1.035-2.13 1.044-2.178-.058-.02-2.05-.83-2.05-3.105 0-1.973 1.562-2.862 1.65-2.93-1.025-1.485-2.598-1.524-3.037-1.524-1.162 0-2.1.704-2.705.704-.635 0-1.485-.665-2.49-.665-1.914 0-3.858 1.582-3.858 4.57 0 1.856.723 3.82 1.612 5.089.751 1.074 1.425 1.953 2.382 1.953z",
    transform: "translate(-1885 -570) translate(1880 568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-1885 -570) translate(1880 568)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.88b892e5.svg";
export { ForwardRef as ReactComponent };